// AUTO-GENERATED by `pnpm generate:api-types`.
// Do not edit by hand. Re-run the script to regenerate.

import { z } from "zod";
import { timestamp } from "@/hooks/firestore/models/timestamp";

export const quaddieMarket = z.object({
  type: z.enum(["EARLY", "LATE", "TREBLE", "DAILY_DOUBLE", "CUSTOM"]),
  name: z.string(),
  eventIds: z.array(z.uuid()),
  meetingIds: z.array(z.uuid()),
  scheduledStartTime: z.union([timestamp, z.null()]).optional(),
  status: z.enum([
    "ACTIVE",
    "SUSPENDED",
    "HANDED_OVER",
    "SETTLED",
    "CANCELLED",
    "DEACTIVATED",
    "UNAVAILABLE",
    "INVALID",
  ]),
  markets: z.record(
    z.string(),
    z.object({
      sport: z.enum([
        "CSGO",
        "LOL",
        "STARCRAFT",
        "STARCRAFT_1",
        "DOTA2",
        "ROCKET_LEAGUE",
        "OVERWATCH",
        "PUBG",
        "CALL_OF_DUTY",
        "UNKNOWN",
        "HEARTHSTONE",
        "NBA2K",
        "RAINBOW_SIX",
        "SMITE",
        "KING_OF_GLORY",
        "FIFA",
        "EMOTORSPORT",
        "ARENA_OF_VALOR",
        "VALORANT",
        "KRUNKER",
        "WARCRAFT",
        "FORTNITE",
        "E_ICE_HOCKEY",
        "BATTLEFIELD_V",
        "WARCRAFT_3",
        "HALO_INFINITE",
        "CALL_OF_DUTY_MOBILE",
        "LOL_WILD_RIFT",
        "APEX_LEGENDS",
        "AGE_OF_EMPIRES",
        "MOBILE_LEGENDS",
        "AMERICAN_FOOTBALL",
        "BASKETBALL",
        "SOCCER",
        "BOXING",
        "MMA",
        "CRICKET",
        "GOLF",
        "ICE_HOCKEY",
        "MOTORSPORT",
        "TENNIS",
        "FORMULA_ONE",
        "RUGBY",
        "AUSSIE_RULES",
        "RUGBY_LEAGUE",
        "TABLE_TENNIS",
        "BASEBALL",
        "OLYMPICS",
        "ATHLETICS",
        "ARCHERY",
        "BADMINTON",
        "BEACH_VOLLEY",
        "DIVING",
        "EQUESTRIAN",
        "FIELD_HOCKEY",
        "GYMNASTICS",
        "HANDBALL",
        "ROWING",
        "SAILING",
        "SKATEBOARDING",
        "SOFTBALL",
        "SURFING",
        "SWIMMING",
        "TRIATHLON",
        "VOLLEYBALL",
        "WATERPOLO",
        "WEIGHTLIFTING",
        "WRESTLING",
        "BASKETBALL_3X3",
        "ALPINE_SKIING",
        "FIGURE_SKATING",
        "FREESTYLE_SKIING",
        "SKELETON",
        "BIATHLON",
        "BOBSLEIGH",
        "NORDIC_COMBINED",
        "SKI_JUMPING",
        "SNOWBOARD",
        "SPEED_SKATING",
        "LUGE",
        "CURLING",
        "POLITICS",
        "HORSE_RACING",
        "GREYHOUNDS",
        "HARNESS_RACING",
        "NOVELTIES",
        "DARTS",
        "SNOOKER",
      ]),
      eventId: z.uuid(),
      meetingId: z.union([z.uuid(), z.null()]),
      marketType: z.string(),
      scheduledStartTime: z.union([timestamp, z.null()]).optional(),
      raceNumber: z.union([z.number(), z.null()]).optional(),
    }),
  ),
  dividends: z.record(
    z.string(),
    z.object({
      outcomeIds: z
        .array(z.uuid())
        .describe("DEPRECATED: use outcomes instead"),
      runners: z.array(z.number()).describe("DEPRECATED: use outcomes instead"),
      dividend: z.number(),
      outcomes: z.array(
        z.object({
          outcomeName: z.string(),
          outcomeId: z.uuid(),
          runnerNumber: z.union([z.number(), z.null()]),
          raceNumber: z.union([z.number(), z.null()]),
          marketId: z.uuid(),
        }),
      ),
    }),
  ),
  expiresAt: z.union([timestamp, z.null()]).optional(),
  sports: z.record(z.string(), z.number()).optional(),
});

export type QuaddieMarket = z.infer<typeof quaddieMarket>;
